import * as React from 'react';

export function SettingsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8892 5.66427L13.9374 7.14215C13.9786 7.4256 13.9997 7.71182 14.0002 7.99863L13.9928 8.2879C13.9834 8.47869 13.9649 8.66888 13.9374 8.85785L15.8892 10.3357L13.9673 13.6643L11.708 12.7111C11.2577 13.0674 10.7585 13.3571 10.2258 13.5713L9.92207 16H6.07841L5.77472 13.5713C5.24199 13.3571 4.7428 13.0674 4.2925 12.7111L2.03315 13.6643L0.111328 10.3357L2.06266 8.85821C1.97947 8.2891 1.97947 7.7109 2.06266 7.14179L0.111328 5.66427L2.03315 2.33567L4.2925 3.28886C4.7428 2.93262 5.24199 2.64294 5.77472 2.42874L6.07841 0H9.92207L10.2258 2.42874C10.7585 2.64294 11.2577 2.93262 11.708 3.28886L13.9673 2.33567L15.8892 5.66427ZM11.0002 8C11.0002 9.65685 9.6571 11 8.00024 11C6.34339 11 5.00024 9.65685 5.00024 8C5.00024 6.34315 6.34339 5 8.00024 5C9.6571 5 11.0002 6.34315 11.0002 8Z"
        fill="#737a8e"
      />
    </svg>
  );
}
